import { useMemo } from 'react';
import { useFilteredTasksQuery } from 'shared/hooks/queries/use-filtered-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { FilterDocument } from 'shared/types/filter-document';

import {
  Options,
  useFilterDocumentFilters,
} from './use-filter-document-filters';
import { useFilteredHabits } from './use-filtered-habits';
import { useFilteredRepeatingTasks } from './use-filtered-repeating-tasks';

export const useTasksByFilterDocument = (
  filterDocument: FilterDocument,
  options: Options = {},
) => {
  const user = useUser();

  const filters = useFilterDocumentFilters(filterDocument, options);

  const { data } = useFilteredTasksQuery(user?.uid, filters);

  const filteredHabits = useFilteredHabits(filters);
  const filteredRepeatingTasks = useFilteredRepeatingTasks(filters);

  return useMemo(
    () => [...(data ?? []), ...filteredHabits, ...filteredRepeatingTasks],
    [data, filteredHabits, filteredRepeatingTasks],
  );
};
